<ng-template let-extraClass="extraClass" #topNav>
  @if (!windowService?.isDesktopRes) {
    <tidy-top-nav
      [title]="'Messages'"
      [class]="extraClass"
      [showLinkIcon]="true"
      [linkIcon]="'create'"
      (linkAction)="goToNewMessagePage()" />
  }
</ng-template>

<ng-container
*ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper [isPrimaryLayer]="true" [hasBottomNav]="!windowService.isDesktopRes" [ngClass]="{'flex-content': windowService.isDesktopRes}">
    <ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'desktop' }" />

    @if (windowService.isDesktopRes) {
      <tidy-desktop-header>
        <div class="wrappable-container">
          <tidy-text
            [title]="'Messages'" />
          <tidy-small-button
            [text]="guestNumber ? ('Guest Number: ' | translate) + guestNumber : ' Guest Number'"
            [image]="guestNumber ? 'assets/svg/chatbox-ellipses-outline.svg' : 'assets/img/add-button-white.svg'"
            (buttonClick)="openAddProxyNumberModal('guest')" />
          <tidy-small-button
            [text]="proNumber ? ('Pro Number: ' | translate) + proNumber : ' Pro Number'"
            [image]="proNumber ? 'assets/svg/chatbox-ellipses-outline.svg' : 'assets/img/add-button-white.svg'"
            (buttonClick)="openAddProxyNumberModal('pro')" />
          @if (showSMSForwardingEnabled && smsForwardingText) {
            <div style="display: flex; align-items: center;">
              <tidy-text
                [helper]="smsForwardingText.helper"
                style="margin-right: 5px" />
              <tidy-image
                src="assets/img/help-circle-outline.svg"
                class="body-size"
                [matTooltip]="smsForwardingText.tooltip | translate"
                [matTooltipPosition]="'below'"
                matTooltipClass="menu-item-tooltip below"
                style="opacity: 0.7" />
            </div>
          }
        </div>
        <div class="non-wrappable-right-aligned-container">
          @if (showLoadingSpinner) {
            <ion-spinner name="lines" class="header-loading-spinner" style="margin-right: 10px" />
          }
          <automations-preview-button
            [tag]="'messages'" />
        </div>
      </tidy-desktop-header>
    }

@if (loaded && !windowService.isDesktopRes) {
  <tidy-row>
    <form [formGroup]="searchForm" novalidate action="#" style="margin-bottom: 10px">
      <tidy-search-input
        formControlName="search"
        [placeholder]="'Search'"
        [icon]="'assets/img/search-header.svg'"
        class="header-search" />
    </form>
  </tidy-row>
}

<!-- First-load skeleton: mirrors the loaded two-pane layout exactly (same
     wrappers/classes/dimensions) so the swap to real content happens in
     place without any shift. Skeleton DOM only exists before the first
     load completes — wasTableLoaded never flips back, so it can't replay. -->
@if (windowService.isDesktopRes && !wasTableLoaded) {
  <div class="messages-split-view messages-skeleton-scope">
    <div class="messages-left-rail">
      <div class="left-rail-search sk-section">
        <ion-skeleton-text [animated]="true" class="sk-search-input" />
        <ion-skeleton-text [animated]="true" class="sk-create-button" />
      </div>
      <div class="conversations-list">
        @for (i of skeletonConversations; track i) {
          <div class="sk-conversation-card sk-item">
            <ion-skeleton-text [animated]="true" class="sk-conv-avatar" />
            <div class="sk-conv-content">
              <div class="sk-conv-top">
                <ion-skeleton-text [animated]="true" class="sk-conv-name" />
                <ion-skeleton-text [animated]="true" class="sk-conv-date" />
              </div>
              <ion-skeleton-text [animated]="true" class="sk-conv-line" />
              <ion-skeleton-text [animated]="true" class="sk-conv-line second" />
            </div>
          </div>
        }
      </div>
    </div>
    <div class="messages-right-panel">
      <div class="chat-header sk-section">
        <div class="chat-header-title">
          <ion-skeleton-text [animated]="true" class="sk-chat-avatar" />
          <ion-skeleton-text [animated]="true" class="sk-chat-title" />
        </div>
      </div>
      <div class="chat-messages-container sk-thread">
        <div class="time-indicator sk-item">
          <ion-skeleton-text [animated]="true" class="sk-time-indicator" />
        </div>
        @for (bubble of skeletonThreadBubbles; track $index) {
          <div class="chat-message sk-item"
               [class.user]="bubble.side === 'user'"
               [class.other]="bubble.side === 'other'"
               [class.last-in-group]="bubble.last">
            <div class="message-content-col">
              @if (bubble.side === 'other' && bubble.last) {
                <ion-skeleton-text [animated]="true" class="message-avatar-initials sk-msg-avatar" />
              }
              <ion-skeleton-text [animated]="true" class="sk-bubble" />
            </div>
          </div>
        }
      </div>
      <div class="chat-input-area sk-section">
        <div class="sk-input-row">
          <ion-skeleton-text [animated]="true" class="sk-input-icon" />
          <ion-skeleton-text [animated]="true" class="sk-input-field" />
          <ion-skeleton-text [animated]="true" class="sk-input-send" />
        </div>
      </div>
    </div>
  </div>
}
@if (windowService.isDesktopRes && wasTableLoaded) {
  <div class="messages-split-view">
    <div class="messages-left-rail">
      <div class="left-rail-search">
        <form [formGroup]="searchForm" novalidate action="#">
          <tidy-search-input
            formControlName="search"
            [placeholder]="'Search'"
            [icon]="'assets/img/search-header.svg'"
            class="header-search" />
        </form>
        <div class="left-rail-icon-button create-button" (click)="toggleNewMessageDropdown()">
          <tidy-image [src]="'assets/svg/create-outline.svg'" class="no-right-margin" style="margin-top: -3px; margin-right: -3px"/>
        </div>
        @if (showNewMessageDropdown) {
          <div class="new-message-dropdown" [style.overflow-y]="'auto'">
            <div class="new-message-dropdown-list">
              <div class="new-message-dropdown-item" (click)="goToNewGuestMessage()">
                <tidy-text [body]="'Message a guest…'" />
              </div>
              @if (proList?.length === 0) {
                <div style="padding: 10px 12px;">
                  <tidy-text [helper]="'No contacts added yet.'" />
                  <br>
                  <tidy-text [actionBody]="'Add Contact'" (action)="goToContactsPage()" class="white-link" />
                </div>
              } @else {
                @for (pro of proList; track pro) {
                  <div class="new-message-dropdown-item" (click)="selectProForNewMessage(pro)">
                    <tidy-text [body]="pro.viewValue" />
                  </div>
                }
              }
            </div>
          </div>
        }
      </div>
      <div class="conversations-list">
        @if (wasTableLoaded) {
          @for (message of shownMessages; track message) {
            <tidy-message-card
              [message]="message"
              [isUnread]="message.isUnread"
              [type]="message.type"
              [initials]="message.initials"
              [tags]="message.tags"
              [date]="message.parsedDateTime"
              [files]="message.files"
              [messageCategory]="message.messageCategory"
              [contactInfo]="message.contactInfo"
              [class.selected]="selectedConversation?.chatRoom?.key === message.chatRoom?.key"
              (click)="goToMessagesPage(message)" />
          }
        }
        @if (shownMessages?.length === 0) {
          <tidy-alert style="margin-bottom: 10px">
            <tidy-row>
              <tidy-text [body]="getEmptyStateMessage()" />
            </tidy-row>
            @if (selectedMessageType !== 'all' || selectedPros?.length || selectedAddresses?.length || searchForm?.value?.search) {
              <tidy-row style="margin-top: 10px;">
                <tidy-button
                  [text]="'Clear All Filters'"
                  [action]="clearAllFilters.bind(this)"
                  class="secondary small" />
              </tidy-row>
            }
          </tidy-alert>
        }
      </div>
    </div>
    <div class="messages-right-panel">
      @if (selectedConversation) {
        <div class="chat-header">
          <div class="chat-header-title">
            <tidy-initials-icon [fullName]="(selectedConversation.homekeeper?.first_name || '') + ' ' + (selectedConversation.homekeeper?.last_name || '')" />
            <tidy-text [title]="selectedConversation.displayName" />
          </div>
          @if (selectedConversation.contactInfo?.linkLabel) {
            <div class="chat-header-assign">
              <span class="assign-link" (click)="onContactAction(selectedConversation)">
                {{ selectedConversation.contactInfo.linkLabel | translate }}
              </span>
            </div>
          }
          @if (!isThreadLoaded || isLoadingMoreThreadMessages) {
            <div class="chat-header-loading-container">
              <div class="chat-header-loading-bar"></div>
            </div>
          }
        </div>
        @if (!isThreadLoaded) {
          <div class="chat-messages-container sk-thread messages-skeleton-scope">
            <div class="time-indicator sk-item">
              <ion-skeleton-text [animated]="true" class="sk-time-indicator" />
            </div>
            @for (bubble of skeletonThreadBubbles; track $index) {
              <div class="chat-message sk-item"
                   [class.user]="bubble.side === 'user'"
                   [class.other]="bubble.side === 'other'"
                   [class.last-in-group]="bubble.last">
                <div class="message-content-col">
                  @if (bubble.side === 'other' && bubble.last) {
                    <ion-skeleton-text [animated]="true" class="message-avatar-initials sk-msg-avatar" />
                  }
                  <ion-skeleton-text [animated]="true" class="sk-bubble" />
                </div>
              </div>
            }
          </div>
        }
        @if (isThreadLoaded) {
          <div class="chat-messages-container" #chatMessagesContainer (scroll)="onThreadScroll($event)">
            @for (msg of threadMessages; track trackThreadMessage($index, msg)) {
              @if (msg.type === 'inquiry') {
                @if (shouldShowTimeIndicator(msg, $index)) {
                  <div class="time-indicator">
                    {{ msg.sent_at | timeIndicator }}
                  </div>
                }
                <div class="chat-message other inquiry-message">
                  <div class="message-content-col">
                    <app-inquiry-card [message]="msg" (openInquiry)="openInquiry(msg)" />
                  </div>
                </div>
              } @else if (msg.type === 'chat_suggestion') {
                @if (msg.content?.chat_suggestion?.status === 'waiting') {
                  <chat-suggestion-card
                    [suggestion]="msg"
                    [homekeeperName]="getHomekeeperNameForSuggestion(msg)"
                    (suggestionPerformed)="onChatSuggestionPerformed(msg)"
                    (suggestionDismissed)="onChatSuggestionDismissed(msg)" />
                }
              } @else {
                @if (shouldShowTimeIndicator(msg, $index)) {
                  <div class="time-indicator">
                    {{ msg.sent_at | timeIndicator }}
                  </div>
                }
                <div class="chat-message"
                     [class.user]="!(msg.from_member | isCounterpartyMessage)"
                     [class.other]="msg.from_member | isCounterpartyMessage"
                     [class.last-in-group]="isLastInGroup(msg, $index)">
                  <div class="message-content-col">
                    @if ((msg.from_member | isCounterpartyMessage) && isLastInGroup(msg, $index)) {
                      <tidy-initials-icon [fullName]="(msg.from_member?.first_name || '') + ' ' + (msg.from_member?.last_name || '')" class="message-avatar-initials" />
                    }
                    <div class="message-bubble">
                      @if (msg.content?.text) {
                        <div class="message-text" [innerHTML]="msg.content.text | linkify | enrichLinks"></div>
                      }
                      @if (msg.content?.files?.length) {
                        <attachment-carousel
                          [files]="msg.content.files"
                          [downloadAction]="downloadFile" />
                      }
                    </div>
                    @if (msg.was_sent_by === 'concierge') {
                      <div class="concierge-label-row">
                        <tidy-text [smallHelper]="'Sent by Concierge'" />
                      </div>
                      <div class="feedback-row">
                        <tidy-pill-button
                          class="small"
                          [image]="'assets/svg/settings-outline.svg'"
                          (buttonClick)="goToConciergeMessageAgent()" />
                        <tidy-pill-button
                          class="small"
                          [image]="'assets/svg/thumbs-up-outline.svg'"
                          (buttonClick)="onMessageThumbClick(msg, 'positive')" />
                        <tidy-pill-button
                          class="small"
                          [image]="'assets/svg/thumbs-down-outline.svg'"
                          (buttonClick)="onMessageThumbClick(msg, 'negative')" />
                      </div>
                      @if (activeFeedbackMessageId === msg.id || closingFeedbackMessageId === msg.id) {
                        <div class="concierge-feedback-form" [class.closing]="closingFeedbackMessageId === msg.id">
                          <div class="concierge-feedback-header">
                            {{ activeFeedbackType === 'positive' ? 'What did you like?' : 'What could be improved?' }}
                          </div>
                          <textarea
                            class="concierge-feedback-textarea"
                            [placeholder]="activeFeedbackType === 'positive' ? ('Tell us what was helpful...' | translate) : ('Tell us how we can do better...' | translate)"></textarea>
                          <div class="concierge-feedback-actions">
                            <button class="concierge-feedback-cancel" (click)="cancelMessageFeedback()">Cancel</button>
                            <button class="concierge-feedback-submit" [disabled]="isSubmittingFeedback" (click)="submitMessageFeedback(msg)">
                              {{ isSubmittingFeedback ? 'Sending...' : 'Submit' }}
                            </button>
                          </div>
                        </div>
                      }
                    }
                  </div>
                </div>
              }
            }
          </div>
          <div class="chat-input-area">
            @if (threadAttachmentPreviews.length > 0) {
              <div class="attachment-preview-container">
                @for (attachment of threadAttachmentPreviews; track attachment.url; let i = $index) {
                  @if (attachment.isImage) {
                    <div class="image-preview">
                      <img [src]="attachment.url" />
                      <div class="remove-image-button">
                        <button mat-icon-button (click)="removeThreadAttachment(i)">
                          <mat-icon>close</mat-icon>
                        </button>
                      </div>
                    </div>
                  } @else {
                    <div class="file-preview">
                      <img src="assets/svg/document-outline.svg" class="file-preview-icon" />
                      <span class="file-preview-name">{{ attachment.filename }}</span>
                      <button mat-icon-button (click)="removeThreadAttachment(i)">
                        <mat-icon>close</mat-icon>
                      </button>
                    </div>
                  }
                }
              </div>
            }
            <form [formGroup]="threadMessageForm" novalidate action="#">
              <tidy-message-input
                #threadMessageInput
                formControlName="message"
                [placeholder]="'Send Message'"
                [form]="threadMessageForm.controls.message"
                [rightIconAction]="boundSendThreadMessage"
                [leftIconAction]="(selectedConversation?.chatRoom?.key | isTextOnlyGuestChatRoom: threadPro?.isGuest) ? null : boundSendThreadAttachment"
                [icon]="null"
                [isSendingMessage]="isSendingThreadMessage"
                [hasAttachment]="threadAttachmentPreviews.length > 0" />
            </form>
          </div>
        }
      } @else {
        <div class="no-conversation-selected">
          <tidy-text [body]="'Select a conversation to view messages'" />
        </div>
      }
    </div>
  </div>
}
@if (!windowService.isDesktopRes) {
  @if (!wasTableLoaded) {
    <div class="mobile-conversations-skeleton messages-skeleton-scope">
      @if (!loaded) {
        <div class="sk-mobile-search sk-section">
          <ion-skeleton-text [animated]="true" class="sk-search-input" />
        </div>
      }
      @for (i of skeletonConversations; track i) {
        <div class="sk-conversation-card sk-item">
          <ion-skeleton-text [animated]="true" class="sk-conv-avatar" />
          <div class="sk-conv-content">
            <div class="sk-conv-top">
              <ion-skeleton-text [animated]="true" class="sk-conv-name" />
              <ion-skeleton-text [animated]="true" class="sk-conv-date" />
            </div>
            <ion-skeleton-text [animated]="true" class="sk-conv-line" />
            <ion-skeleton-text [animated]="true" class="sk-conv-line second" />
          </div>
        </div>
      }
    </div>
  }
  @if (wasTableLoaded) {
    @for (message of shownMessages; track message) {
      <tidy-message-card
        [message]="message"
        [isUnread]="message.isUnread"
        [type]="message.type"
        [initials]="message.initials"
        [tags]="message.tags"
        [date]="message.parsedDateTime"
        [files]="message.files"
        [messageCategory]="message.messageCategory"
        [contactInfo]="message.contactInfo"
        (click)="goToMessagesPage(message)">
      ></tidy-message-card>
    }
  }
  @if (shownMessages?.length === 0) {
    <tidy-alert style="margin-bottom: 10px">
      <tidy-row>
        <tidy-text [body]="getEmptyStateMessage()" />
      </tidy-row>
      @if (selectedMessageType !== 'all' || selectedPros?.length || selectedAddresses?.length || searchForm?.value?.search) {
        <tidy-row style="margin-top: 10px;">
          <tidy-button
            [text]="'Clear All Filters'"
            [action]="clearAllFilters.bind(this)"
            class="secondary small" />
        </tidy-row>
      }
    </tidy-alert>
  }
}

</tidy-wrapper>
</ng-template>

<app-scroll-wrapper
  [isfullWidthContent]="true"
  [templateContent]="content"
  [desktopWidthContent]="desktopWidthContent" />

<tidy-bottom-nav activeRoute="/messages" />

@if (showAboutThisPage) {
  <tidy-about-this-page [page]="'messages'" (dismissed)="dismissAboutThisPage()" />
}